import {
  HttpTransportType,
  HubConnection,
  HubConnectionBuilder,
  LogLevel
} from '@microsoft/signalr'

const baseUrl = process.env.VUE_APP_BASE_URL_API

/**
 * Creates a new WebSocket connection.
 *
 * @param tokenV2 Valid token with an AccountId.
 */
export function createConnection (tokenV2: string): HubConnection {
  return new HubConnectionBuilder()
    .withUrl(`${baseUrl}/ws/events`, {
      accessTokenFactory: () => tokenV2,
      transport: HttpTransportType.WebSockets | HttpTransportType.LongPolling
    })
    .configureLogging(LogLevel.None)
    .withAutomaticReconnect()
    .build()
}
